module.exports = __webpack_public_path__ + "img/1alB-ll-llit.c87014f6.jpg";